<template>
	<div class="mb-n4 px-3">{{ label }}</div>
</template>
<script>
	export default {
		props: [
			'id',
			'label',
			'value',
			'error',
			'errorMessages',
		],
	}
</script>